/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 2095
// module chunks = 2